import { render, staticRenderFns } from "./CallFilterDropdown.vue?vue&type=template&id=5d80eda1&"
import script from "./CallFilterDropdown.vue?vue&type=script&lang=js&"
export * from "./CallFilterDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports